import axios from "../../../../helper/axios";
import * as actionTypes from "../../actionTypes";

// select project
export const selectProjectId = (projectId) => {
  return {
    type: actionTypes.SELECT_CLIENT_PROJECT,
    projectId,
  };
};

// fetch project
export const fetchClientProjectsStart = () => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECTS_START,
  };
};

export const fetchClientProjectsSuccess = (projects, count) => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECTS_SUCCESS,
    projects,
    count,
  };
};

export const fetchClientProjectsFail = (error) => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECTS_FAIL,
    error,
  };
};

export const fetchClientProjects = (clientId, pageN, pageS) => {
  return (dispatch) => {
    dispatch(fetchClientProjectsStart());
    axios
      .get(
        `admin/client/project/${clientId}?pageNumber=${pageN}&pageSize=${pageS}`
      )
      .then((res) => {
        // console.log(res);

        dispatch(fetchClientProjectsSuccess(res.data.projects, res.data.total));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchClientProjectsFail(err.response.data.message));
        } else {
          dispatch(fetchClientProjectsFail("Something went wrong"));
        }
      });
  };
};

// Create project for client
export const createClientProjectStart = () => {
  return {
    type: actionTypes.CREATE_CLIENT_PROJECT_START,
  };
};

export const createClientProjectSuccess = (newProject, msg) => {
  return {
    type: actionTypes.CREATE_CLIENT_PROJECT_SUCCESS,
    newProject,
    msg,
  };
};

export const createClientProjectFail = (error) => {
  return {
    type: actionTypes.CREATE_CLIENT_PROJECT_FAIL,
    error,
  };
};

export const createClientProject = (clientId, data, callBack) => {
  return (dispatch) => {
    dispatch(createClientProjectStart());
    axios
      .post(`admin/client/project/${clientId}`, data)
      .then((res) => {
        // console.log(res);
        dispatch(
          createClientProjectSuccess(res.data.project, res.data.message)
        );
        callBack();
      })
      .catch((err) => {
        console.log(err);
        // console.log(err.response);
        if (err.response) {
          dispatch(createClientProjectFail(err.response.data.message));
        } else {
          dispatch(createClientProjectFail("Something went wrong"));
        }
      });
  };
};

// DELETE folder
export const deleteClientProjectStart = () => {
  return {
    type: actionTypes.DELETE_CLIENT_PROJECT_START,
  };
};

export const deleteClientProjectSuccess = (projectId, msg) => {
  return {
    type: actionTypes.DELETE_CLIENT_PROJECT_SUCCESS,
    projectId,
    msg,
  };
};
export const deleteClientProjectFail = (error) => {
  return {
    type: actionTypes.DELETE_CLIENT_PROJECT_FAIL,
    error,
  };
};

export const deleteClientProject = (projectId) => {
  return (dispatch) => {
    dispatch(deleteClientProjectStart());
    axios
      .delete(`api/v1/admin/client/project/${projectId}`)
      .then((res) => {
        // console.log(res);
        // console.log(projectId);
        dispatch(deleteClientProjectSuccess(projectId, "PROJECT DELETED"));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(deleteClientProjectFail(err.response.data.message));
        } else {
          dispatch(deleteClientProjectFail("Something went wrong"));
        }
      });
  };
};

export const clearClientProjectMsg = () => {
  return {
    type: actionTypes.CLEAR_MSG_CLIENT_PROJECT,
  };
};
